module.exports = __webpack_public_path__ + "img/tarj1-1.8bbd06fc.svg";